import { render } from "./stripe_checkout.vue?vue&type=template&id=56660a33"
import script from "./stripe_checkout.vue?vue&type=script&lang=js"
export * from "./stripe_checkout.vue?vue&type=script&lang=js"

import "./stripe_checkout.vue?vue&type=style&index=0&id=56660a33&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__